import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faUpRightFromSquare,
  faCopy,
  faShareNodes,
} from '@fortawesome/free-solid-svg-icons';
import './SmartQuiz.css';

interface Props {
  game: any;
  gameTitle: string;
  questionCount: number;
  difficulty: string;
  timePerQuestion: number;
}

const StepPublish: React.FC<Props> = ({
  game,
  gameTitle,
  questionCount,
  difficulty,
  timePerQuestion,
}) => {
  const navigate = useNavigate();
  const gameCode = game?.gameId?.toUpperCase();
  const [copied, setCopied] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');

  const copyCode = () => {
    const url = `${process.env.REACT_APP_FRONTEND_URL}/join?gameId=${gameCode}`;
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="sq-step4">
      {/* Success banner */}
      <div className="sq-step4__banner">
        <span className="sq-step4__banner-emoji">🎉</span>
        <div className="sq-step4__banner-text">
          <h2>Your game is ready!</h2>
          <p>
            {gameTitle} · {questionCount} questions · Smart Quiz
          </p>
        </div>
        <div className="sq-step4__banner-actions">
          <button
            className="sq-btn sq-btn--primary"
            onClick={() =>
              navigate(`/dashboard/games/game/${game.gameId}/lobby`, {
                state: {
                  gameType: game?.gameType,
                  gameStatus: game?.gameStatus,
                  gameTitle: game?.gameTitle,
                  totalGame: game?.totalGame,
                },
              })
            }
          >
            <FontAwesomeIcon icon={faPlay} /> Host Lobby
          </button>
          <button
            className="sq-btn sq-btn--outline"
            onClick={() => navigate('/dashboard/home')}
          >
            <FontAwesomeIcon icon={faUpRightFromSquare} /> My Games
          </button>
        </div>
      </div>

      <div className="sq-step4__body">
        {/* Left: Game code */}
        <div className="sq-step4__code-card">
          <span className="sq-step4__code-label">GAME CODE</span>
          <h1 className="sq-step4__code">{gameCode}</h1>
          <p className="sq-step4__code-sub">
            Share this code with players to join
          </p>
          <button
            className="sq-btn sq-btn--outline sq-btn--full"
            onClick={copyCode}
          >
            <FontAwesomeIcon icon={faCopy} /> {copied ? 'Copied!' : 'Copy Code'}
          </button>
          <button className="sq-btn sq-btn--primary sq-btn--full">
            <FontAwesomeIcon icon={faShareNodes} /> Share Invite Link
          </button>
        </div>

        {/* Right: Stats + Invite */}
        <div className="sq-step4__right">
          <div className="sq-step4__stats">
            <div className="sq-step4__stat">
              <span className="sq-step4__stat-value">{questionCount}</span>
              <span className="sq-step4__stat-label">Questions</span>
            </div>
            <div className="sq-step4__stat">
              <span className="sq-step4__stat-value">{difficulty}</span>
              <span className="sq-step4__stat-label">Difficulty</span>
            </div>
            <div className="sq-step4__stat">
              <span className="sq-step4__stat-value">{timePerQuestion}s</span>
              <span className="sq-step4__stat-label">Time/Q</span>
            </div>
          </div>

          <div className="sq-step4__invite-card">
            <div className="sq-step4__invite-header">
              <h4>Invite Players</h4>
              <span className="sq-step4__invite-count">👥 0 invited</span>
            </div>
            <div className="sq-step4__invite-row">
              <input
                className="sq-input"
                type="text"
                placeholder="Search by username or email..."
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
              />
              <button className="sq-btn sq-btn--primary">Invite</button>
            </div>
          </div>

          <div className="sq-step4__qr-card">
            <div>
              <h4>Share via QR Code</h4>
              <p className="sq-step4__qr-sub">
                Players can scan to join instantly
              </p>
            </div>
            <button className="sq-btn sq-btn--outline">Generate QR</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepPublish;
